import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'state'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'
import { AuthorizationParams } from '@mprolab/sdk'
import type { SignableWallet } from 'utils/getSignature'
import useToast from 'hooks/useToast'
import { getUserAuthData } from '../actions'

export interface VerifyUserProps {
  onSuccessCallback?: (authParams?: AuthorizationParams) => void | Promise<any>
  onErrorCallback?: (error: any) => void | Promise<any>
  customProvider?: SignableWallet
  customAccount?: string
}

export const useVerify = () => {
  const { account } = useWeb3React()
  const dispatch = useDispatch<AppDispatch>()
  const { provider } = useWeb3React()
  const { toastError } = useToast()

  const verifyUser = useCallback(
    async (props?: VerifyUserProps) => {
      try {
        const data = await dispatch(
          // @ts-ignore Need to ignore this error due to missin corner prop in Web3Provider from useWeb3React
          getUserAuthData({
            account: props?.customAccount || account,
            provider: props?.customProvider || provider
          })
        ).unwrap()
        if (props?.onSuccessCallback) props?.onSuccessCallback(data as AuthorizationParams)
      } catch (error) {
        const msg =
          error && typeof error === 'object' && 'message' in error && typeof (error as Error).message === 'string'
            ? (error as Error).message
            : 'An error occurred during wallet verification. Please try again.'
        toastError(msg)
        console.error(error)
        if (props?.onErrorCallback) props?.onErrorCallback(error)
      }
    },
    [account, dispatch, provider]
  )

  return { verifyUser }
}
